import { render, staticRenderFns } from "./InternalError.vue?vue&type=template&id=047ee830"
import script from "./InternalError.vue?vue&type=script&lang=js"
export * from "./InternalError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports